// src/features/support/components/TicketStatusBadge.tsx
import clsx from 'clsx';
import type { TicketStatus } from './TicketRow';

const STATUS_CONFIG: Record<TicketStatus, { label: string; className: string }> = {
  open: {
    label: 'باز',
    className: 'text-sky-400 bg-sky-400/10 border-sky-400/20',
  },
  pending: {
    label: 'در انتظار پاسخ',
    className: 'text-amber-400 bg-amber-400/10 border-amber-400/20',
  },
  closed: {
    label: 'بسته شده',
    className: 'text-slate-400 bg-slate-400/10 border-slate-400/20',
  },
};

interface TicketStatusBadgeProps {
  status: TicketStatus;
}

export function TicketStatusBadge({ status }: TicketStatusBadgeProps) {
  const { label, className } = STATUS_CONFIG[status];

  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center rounded-full border px-2.5 py-1 text-xs font-medium',
        className,
      )}
    >
      {label}
    </span>
  );
}
